exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-photo-zoom-pro img {\n  -o-object-fit: scale-down;\n     object-fit: scale-down;\n  max-height: calc(100vh - 62px);\n}\n", ""]);

// exports
